import React, {useState} from 'react';
import {Button, Form, Input, message, Select, Modal, Alert} from "antd";
import {PlusOutlined, SaveOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {addVehicle} from "../../../slices/vehicleSlice";
import {useNewVehicleMutation, useGetVehicleQuery} from "../../../slices/rootApiSlices/vehicleApiSlice";
import SearchCompany from "../../../components/SearchCompany";
import SearchDevice from "../../../components/SearchDevice";


const AddVehicleModal = () => {

    const [form] = Form.useForm();
    const {Option} = Select;
    const {user} = useSelector(state => state.auth);
    const [vehicleHandle, {isLoading}] = useNewVehicleMutation();
    const {refetch} = useGetVehicleQuery(user?.token);

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [chassisNumber, setChassisNumber] = useState("");
    const [fuelType, setFuelType] = useState("");
    const [brand, setBrand] = useState("");
    const [year, setYear] = useState("");
    const [plateNumber, setPlateNumber] = useState("");
    const [operationNumber, setOperationNumber] = useState("");
    const [company_id, setCompanyID] = useState("");
    const [device_id, setDeviceID] = useState("");
    const [isActive, setIsActive] = useState(false);

    const showModal = () => {
        setOpen(true);
    };

    const handleOk = async () => {
        const newVehicle = {
            chassisNumber,
            plateNumber,
            operationNumber,
            company_id,
            device_id,
            year: form.getFieldValue("year"),
            brand: form.getFieldValue("brand"),
            fuelType: form.getFieldValue("fuelType"),
            isActive: form.getFieldValue("isActive"),
        };
        try {
            const res = await vehicleHandle({token: user?.token, data: newVehicle}).unwrap();
            dispatch(addVehicle(res?.data));
            setOpen(false);
            form.resetFields();
            refetch();
            message.success(res?.messageTR, 3);
        } catch (e) {
            console.log(e)
            message.error(e?.data?.messageTR || 'Bir hata oluştu.');

        }
    };


    const handleCancel = () => {
        setOpen(false);
        message.warning('Araç eklemekten vazgeçildi', 3);
    };


    return (
        <>
            <Button type="primary" onClick={showModal} style={{marginBottom: 10}} icon={<PlusOutlined/>}>
                Yeni Araç Ekle
            </Button>
            <Modal
                width={730}
                title="Yeni Araç Ekle"
                open={open}
                onOk={handleOk}
                cancelText="Vazgeç"
                confirmLoading={isLoading}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" type="primary" danger onClick={handleCancel}>
                        Vazgeç
                    </Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={handleOk} icon={<SaveOutlined/>}>
                        Kaydet
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    name="add-vehicle"
                    onFinish={handleOk}
                    onFinishFailed={handleCancel}
                    autoComplete="off"
                >
                    <Form.Item label="Kapı / Plaka No" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="operationNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen kapı numarasını giriniz !',
                                },
                            ]}
                            onChange={e => setOperationNumber(e.target.value)}
                            value={operationNumber}
                        >
                            <Input placeholder="Kapı numarası"/>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="plateNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen plaka giriniz !',
                                },
                            ]}
                            onChange={e => setPlateNumber(e.target.value)}
                            value={plateNumber}
                        >
                            <Input placeholder="Plaka no"/>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Şase No / Araç Durumu" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="chassisNumber"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen şase numarasını giriniz !',
                                },
                            ]}
                            onChange={e => setChassisNumber(e.target.value)}
                            value={chassisNumber}
                        >
                            <Input placeholder="Şase no"/>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="isActive"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen durum giriniz !',
                                },
                            ]}
                            value={isActive}
                        >
                            <Select
                                onChange={(e) => setIsActive({...isActive})}
                                placeholder="Durum seçiniz.."
                                allowClear
                            >
                                <Option value={true}>Aktif</Option>
                                <Option value={false}>Pasif</Option>
                            </Select>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Yakıt Türü / Cihaz ID" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="fuelType"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen yakıt türünü seçiniz !',
                                },
                            ]}
                            onChange={e => setFuelType(e.target.value)}
                            value={fuelType}
                        >
                            <Select
                                onChange={(e) => setFuelType({...fuelType})}
                                placeholder="Yakıt türünü seçiniz.."
                                allowClear
                            >
                                <Option value="diesel">Diesel</Option>
                                <Option value="cng">CNG</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="device_id"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen cihaz id giriniz !',
                                },
                            ]}
                            value={device_id}
                        >
                            <SearchDevice onChange={e => setDeviceID(e)}/>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Marka / Yıl" style={{marginBottom: 0}}>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                            name="brand"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen marka giriniz !',
                                },
                            ]}
                            value={brand}
                        >
                            <Select
                                onChange={(e) => setBrand({...brand})}
                                placeholder="Marka seçiniz.."
                                allowClear
                            >
                                <Option value="mercedes">Mercedes</Option>
                                <Option value="otokar">Otokar</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                            name="year"
                            rules={[
                                {
                                    required: true,
                                    message: 'lütfen yıl giriniz !',
                                },
                            ]}
                            value={year}
                        >
                            <Select
                                onChange={(e) => setYear({...year})}
                                placeholder="Yıl seçiniz.."
                                allowClear
                            >
                                <Option value="2024">2024</Option>
                                <Option value="2023">2023</Option>
                                <Option value="2022">2022</Option>
                                <Option value="2021">2021</Option>
                                <Option value="2020">2020</Option>
                                <Option value="2019">2019</Option>
                                <Option value="2018">2018</Option>
                                <Option value="2017">2017</Option>
                                <Option value="2016">2016</Option>
                                <Option value="2015">2015</Option>
                                <Option value="2014">2014</Option>
                                <Option value="2013">2013</Option>
                                <Option value="2012">2012</Option>
                                <Option value="2011">2011</Option>
                                <Option value="2010">2010</Option>
                            </Select>
                        </Form.Item>
                    </Form.Item>
                    <Form.Item label="Şirket Seçiniz" name="company_id">
                        <SearchCompany onChange={e => setCompanyID(e)}/>
                    </Form.Item>
                    <Alert
                        showIcon
                        message="Cihazın enerjisi olduğundan ve sim kartın takılı olduğundan emin olun !"
                        type="warning"
                    />
                </Form>
            </Modal>
        </>
    );
};

export default AddVehicleModal;
